import { useEditorStore } from '@/stores/editorStore';
import { Card } from '@/components/ui/card';
import { clsx } from 'clsx';

export function ContentStats() {
  const { plainTextContent } = useEditorStore();

  const charCount = plainTextContent.length;
  const wordCount =
    plainTextContent.trim() === '' ? 0 : plainTextContent.trim().split(/\s+/).length;
  const lineCount = plainTextContent.split('\n').length;
  const readTime = Math.ceil(wordCount / 200); // 200 wpm

  // LinkedIn limits
  const maxChars = 3000;
  const isOverLimit = charCount > maxChars;
  const isOptimal = wordCount >= 50 && wordCount <= 300; // Arbitrary optimal range based on ADR hint

  return (
    <Card>
      <h3 className="text-lg font-serif font-medium mb-4">Stats</h3>

      <div className="grid grid-cols-2 gap-4 mb-4">
        <div className="bg-background p-3 rounded-lg text-center">
          <div className={clsx('text-2xl font-bold', isOverLimit ? 'text-error' : 'text-primary')}>
            {charCount}
          </div>
          <div className="text-xs text-text-secondary uppercase tracking-wide">Characters</div>
          <div className="text-[10px] text-text-secondary">Max 3,000</div>
        </div>

        <div className="bg-background p-3 rounded-lg text-center">
          <div className={clsx('text-2xl font-bold', isOptimal ? 'text-accent' : 'text-primary')}>
            {wordCount}
          </div>
          <div className="text-xs text-text-secondary uppercase tracking-wide">Words</div>
          <div className="text-[10px] text-text-secondary">Optimal: 150-300</div>
        </div>
      </div>

      <div className="flex justify-between text-sm text-text-secondary border-t border-border pt-3">
        <span>
          Lines: <span className="font-medium text-text-primary">{lineCount}</span>
        </span>
        <span>
          Read time: <span className="font-medium text-text-primary">~{readTime} min</span>
        </span>
      </div>

      {isOverLimit && (
        <div className="mt-3 text-xs text-error font-medium bg-error/10 p-2 rounded">
          ⚠️ Character limit exceeded!
        </div>
      )}
    </Card>
  );
}
